import Vue from 'vue'
import Vuex from 'vuex'

import parameters from './modules/parameters'
import registers from './modules/registers'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: { parameters, registers }
})